import {isRtl, toggleSliderNextButton, isLastSlideVisibleRtl, isLastSlideVisibleLtr} from "../utils/helpers";
export default class TabsSlider {
    constructor() {
        this.initSlider();
    }

    initSlider() {
        $('.tabs-primary .tabs_list_container').each((index, element) => {
            const $container = $(element);
            const containerWidth = $container.parent().width();
            const tabsWidth = $container.children().toArray().reduce((total, el) => total + $(el).outerWidth(true), 0);

            if (tabsWidth > containerWidth) {
                if (!$container.hasClass('slick-initialized')) {
                    $container.slick({
                        slidesToScroll: 1,
                        slidesToShow: 1,
                        infinite: false,
                        arrows: true,
                        mobileFirst: true,
                        centerMode: true,
                        rtl: isRtl(),
                        responsive: [
                            {
                                breakpoint: 767,
                                settings: {
                                    variableWidth: true,
                                    centerMode: false,
                                }
                            }
                        ]
                    });
                }
            } else {
                if ($container.hasClass('slick-initialized')) {
                    $container.slick('unslick');
                }
            }

            const updateSliderState = () => {
                if (window.innerWidth < 768) {
                    const currentSlide = $container.slick('slickCurrentSlide');
                    this.activateTab(currentSlide);
                }

                const slick = $container.slick('getSlick');
                const wraRect = $('.slick-list', $container).get(0).getBoundingClientRect();
                
                if (isRtl()) {
                    const firstSlideRect = slick.$slides[0].getBoundingClientRect();
                    toggleSliderNextButton($container, isLastSlideVisibleRtl(firstSlideRect, wraRect));
                } else {
                    const lastSlideRect = slick.$slides[slick.slideCount - 1].getBoundingClientRect();
                    toggleSliderNextButton($container, isLastSlideVisibleLtr(lastSlideRect, wraRect));
                }
            };

            $container.on('afterChange', updateSliderState);
            $(window).on('resize', updateSliderState);
        });
    }

    activateTab(index) {
        $('.tabs-primary .tabs_list_container').each((_, element) => {
            $(element).children().removeClass('active');
            $(element).children().eq(index).addClass('active');
        });
    }
}
